const getIsFinanceExam = ({ productSlug }) => {
  return /finra/i.test(productSlug);
};

export default getIsFinanceExam;
